import TestInfo from '../../../../../../../../Models/TestInfo';
import TestSelectionFormFieldNames from '../../../../../../Models/TestSelectionFormFieldNames';
import BaseTestCard from '../BaseTestCard/BaseTestCard';
import { PreviewQuestionsProps } from '../PreviewQuestions/Dialog/usePreviewQuestions';
import { resourceBaseUrl } from '@/AppSettings';
import UIStrings from '@/Utils/UIStrings';

interface AptitudeTestCardProps extends Omit<PreviewQuestionsProps, 'testType'> {
    test: TestInfo;
}

function AptitudeTestCard({ test, demoQuestions, likertOptions }: AptitudeTestCardProps) {
    return (
        <BaseTestCard
            {...test}
            testName={UIStrings.Aptitude}
            fieldName={TestSelectionFormFieldNames.isAptitudeSelected}
            imageURL={`${resourceBaseUrl}/images/Aptitude.png`}
            demoQuestions={demoQuestions}
            likertOptions={likertOptions}
        />
    );
}

export default AptitudeTestCard;
